import styled from "styled-components";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import PrimaryButton from "../../../../../components/FormControls/PrimaryButton";
import SecondaryButton from "../../../../../components/FormControls/SecondaryButton";
import request from "../../../../../api/request";
import NarrowGrid from "../../../../../components/NarrowGrid";
import FormStringInput from "../../../../../components/FormControls/FormStringInput";
import FormSelectWithLabel from "../../../../../components/FormControls/FormSelectWithLabel";
import FormNumberInputNoSpinner from "../../../../../components/FormControls/FormNumberInputNoSpinner";
import FormCheckBoxWithRightLabel from "../../../../../components/FormControls/FormCheckBoxWithRightLabel";
import { NotificationManager } from 'react-notifications';
import TabBar from "../../../../../components/TabBar";
import { useNavigate } from 'react-router-dom';

const StyledAccountSections = styled.div`
`;

const WhiteBoard = styled.div`
    background-color: white;
    width: 750px;
    box-sizing: border-box;
    min-height: 526px;
    padding: 30px;
    margin-bottom: 30px;
    margin-left: 30px;
    color: ${(props) => props.theme.color.gray};
`;

function AccountSections(props) {

    let defaultPath = '/systemstructure/accountsections/';

    let defaultTabPath = '';
    let {subTabPath} = useParams();
    const navigate = useNavigate();

    let currentYear = new Date().getFullYear();

    const [loadedPage, setLoadedPage] = useState(false);
    const [isSaving, setIsSaving] = useState(false);
    const [isDeletingAccountSection, setIsDeletingAccountSection] = useState(false);
    const [isFetchedAccountTypes, setIsFetchedAccountTypes] = useState(false);
    const [tabs, setTabs] = useState([]);
    const [accountSections, setAccountSections] = useState([]);
    const [selectedFundTypeCode, setSelectedFundTypeCode] = useState('');
    const [selectedAccountSection, setSelectedAccountSection] = useState(null);
    const [selectedAccountSectionId, setSelectedAccountSectionId] = useState(null);
    const [isAddAccountSectionMode, setIsAddAccountSectionMode] = useState(false);
    const [gridColumns, setGridColumns] = useState([
        {id: 'Number', type: 'String', width: 100, textAlign: 'center'},
        {id: 'Description', type: 'String', width: 200, textAlign: 'left'},
    ]);
    const [gridData, setGridData] = useState({groups: ['Type: Branches', 'Type: Sub-branches'], items: [[], []]});

    const [recordType, setRecordType] = useState(1);
    const [accountingYear, setAccountingYear] = useState(props.baseYear);
    const [sectionNumber, setSectionNumber] = useState(0);
    const [sectionDescription, setSectionDescription] = useState('');
    const [receiptPayment, setReceiptPayment] = useState(1);
    const [reportSection, setReportSection] = useState(0);
    const [carriedForwardBalanceLine, setCarriedForwardBalanceLine] = useState(false);
    const [broughtForwardBalanceLine, setBroughtForwardBalanceLine] = useState(false);
    
    const [needsValidation, setNeedsValidation] = useState(false);
    const [isAddingDuplicatedAccountSection, setIsAddingDuplicatedAccountSection] = useState(false);
    
    let years = [];
    for (let i = currentYear - 10; i < currentYear + 5; i ++) {
        years.push(i);
    }

    let branchTypes = ['Branch', 'Sub-Branch'];
    const branchTypeStringToInt = (branchTypeStr) => {
        if (branchTypeStr === 'Branch') {
            return 1;
        } else {
            return 2;
        }
    }
    const onChangeRecordType = (e) => {
        let bType = branchTypeStringToInt(e.target.value);
        setRecordType(bType);
    }

    let sectionTypes = ['Receipt', 'Payment'];
    const sectionTypeStringToInt = (str) => {
        if (str === 'Receipt') {
            return 1;
        } else {
            return 2;
        }
    }
    const onChangeReceiptPayment = (e) => {
        let type = sectionTypeStringToInt(e.target.value);
        setReceiptPayment(type);
    }

    const onSelectGridItem = (item) => {
        setSelectedAccountSectionId(item.Id);
        setSelectedAccountSection(item);
    }
    
    const fetchFundTypes = async () => {
        try {
            let tabs = [];

            const resp = (await request('database', 'fetchFundTypes'));
            if (resp.ok) {
                resp.data.map((fundType, index) => {
                    if (fundType.AccountingYear === props.baseYear && !tabs.find((itm) => itm.FundTypeCode === fundType.FundTypeCode)) {
                        tabs.push({text: fundType.FundTypeCode.replace(/\s/g, '') + ' - ' + fundType.FundTypeName, path: fundType.FundTypeCode.replace(/\s/g, ''), FundTypeCode: fundType.FundTypeCode})
                    }
                });
                setTabs(tabs);
                setIsFetchedAccountTypes(true);
                if (tabs.length > 0) {
                    if (!subTabPath) {
                        navigate(defaultPath + tabs[0].path);
                    } else {
                        let selectedTab = tabs.find((itm) => itm.FundTypeCode.replace(/\s/g, '') === subTabPath);
                        if (selectedTab) {
                            setSelectedFundTypeCode(selectedTab.FundTypeCode);
                        }
                    }
                }
            } else {
                console.log('Failed fetchFundTypes');
                NotificationManager.error(resp.data);
                return false;
            }
        } catch (e) {
            console.log('Failed to fetch fund types: ', e);
            return false;
        }
        return true;
    }

    const fetchFundSections = async (recordTypeToSelect, sectionNumberToSelect) => {
        try {
            let accountSectionList = [];

            const resp = (await request('database', 'fetchFundSections'));
            if (resp.ok) {
                resp.data.map((accountSection, index) => {
                    accountSectionList.push(accountSection);
                });
                setAccountSections(accountSectionList);
                rebuildGridData(accountSectionList, recordTypeToSelect, sectionNumberToSelect);
            } else {
                console.log(resp.data);
                NotificationManager.error(resp.data);
                return false;
            }
        } catch (e) {
            console.log('Failed to fetch fund sections: ', e);
            return false;
        }
        return true;
    }

    const onDeleteFundSection = async () => {
        if (selectedAccountSection && selectedFundTypeCode) {
            setIsDeletingAccountSection(true);
            let deleteData = {};
            deleteData.RecordType = selectedAccountSection.RecordType;
            deleteData.AccountingYear = selectedAccountSection.AccountingYear;
            deleteData.SectionNumber = selectedAccountSection.SectionNumber;
            deleteData.FundTypeCode = selectedFundTypeCode;
            
            const resp = (await request('database', 'deleteFundSection', [deleteData]));
            if (resp.ok) {
                setSelectedAccountSection(null);
                setSelectedAccountSectionId(null);
                fetchFundSections();
                NotificationManager.success('Successfully deleted account section');
            } else {
                console.log(resp.data);
                NotificationManager.error(resp.data);
            }
            setIsDeletingAccountSection(false);
        }
    }

    const onSaveChanges = async () => {
        if (isAddAccountSectionMode) { // adding new item
            if (sectionDescription === '') {
                setNeedsValidation(true);
            } else {
                // check duplicated code
                if (accountSections.length > 0 && (accountSections.find((itm) => itm.RecordType === recordType && itm.AccountingYear === accountingYear && itm.FundTypeCode.replace(/\s/g, '') === selectedFundTypeCode.replace(/\s/g, '') && itm.SectionNumber === sectionNumber))) {
                    setIsAddingDuplicatedAccountSection(true);
                } else {
                    setIsSaving(true);
                    let saveData = {};
                    saveData.RecordType = recordType;
                    saveData.AccountingYear = accountingYear;
                    saveData.sectionDescription = sectionDescription;
                    saveData.FundTypeCode = selectedFundTypeCode;
                    saveData.SectionNumber = sectionNumber;
                    saveData.ReceiptPayment = receiptPayment;
                    saveData.ReportSection = reportSection;
                    saveData.CarriedForwardBalanceLine = carriedForwardBalanceLine;
                    saveData.BroughtForwardBalanceLine = broughtForwardBalanceLine;

                    const resp = (await request('database', 'createFundSection', [saveData]));
                    if (resp.ok) {
                        fetchFundSections(recordType, sectionNumber);
                        NotificationManager.success('Successfully added fund section');
                    } else
                    {
                        console.log(resp.data);
                        NotificationManager.error(resp.data);
                    }
                    setIsSaving(false);
                    setIsAddAccountSectionMode(false);
                }
            }
        } else {
            if (sectionDescription === '') {
                setNeedsValidation(true);
            } else {
                // check duplicated code
                if (accountSections.length > 0 && (accountSections.find((itm) => (itm.RecordType !== selectedAccountSection.RecordType || itm.AccountingYear !== selectedAccountSection.AccountingYear || itm.FundTypeCode.replace(/\s/g, '') !== selectedFundTypeCode.replace(/\s/g, '') || itm.SectionNumber !== selectedAccountSection.SectionNumber) && itm.RecordType === recordType && itm.AccountingYear === accountingYear && itm.FundTypeCode.replace(/\s/g, '') === selectedFundTypeCode.replace(/\s/g, '') && itm.SectionNumber === sectionNumber))) {
                    setIsAddingDuplicatedAccountSection(true);
                } else {
                    setIsSaving(true);
                    let saveData = {};
                    saveData.RecordType = recordType;
                    saveData.AccountingYear = accountingYear;
                    saveData.sectionDescription = sectionDescription;
                    saveData.SectionNumber = sectionNumber;
                    saveData.ReceiptPayment = receiptPayment;
                    saveData.ReportSection = reportSection;
                    saveData.CarriedForwardBalanceLine = carriedForwardBalanceLine;
                    saveData.BroughtForwardBalanceLine = broughtForwardBalanceLine;

                    saveData.OldRecordType = selectedAccountSection.RecordType;
                    saveData.OldSectionNumber = selectedAccountSection.SectionNumber;
                    saveData.OldAccountingYear = selectedAccountSection.AccountingYear;
                    saveData.OldFundTypeCode = selectedAccountSection.FundTypeCode;

                    const resp = (await request('database', 'updateFundSection', [saveData]));
                    if (resp.ok) {
                        fetchFundSections(recordType, sectionNumber);
                        NotificationManager.success('Successfully updated fund section');
                    } else
                    {
                        console.log(resp.data);
                        NotificationManager.error(resp.data);
                    }
                    setIsSaving(false);
                    setIsAddAccountSectionMode(false);
                }
            }
        }
    }

    const rebuildGridData = (accountSections, recordTypeToSelect, sectionNumberToSelect) => {
        if (accountSections && accountSections.length > 0) {
            let accountSectionsBranch = [];
            let accountSectionsSubBranch = [];
            accountSections.map((accountSection, index) => {
                if (accountSection.AccountingYear === props.baseYear && accountSection.FundTypeCode.replace(/\s/g, '') === selectedFundTypeCode.replace(/\s/g, '')) {
                    let gridItem = {Id: index, Number: accountSection.SectionNumber.toString(), Description: accountSection.SectionDescription, ...accountSection};
                    if (accountSection.RecordType === 1) {
                        accountSectionsBranch.push(gridItem);
                    } else {
                        accountSectionsSubBranch.push(gridItem);
                    }
                    if (recordTypeToSelect && sectionNumberToSelect && accountSection.RecordType === recordTypeToSelect && accountSection.SectionNumber === sectionNumberToSelect) {
                        setSelectedAccountSectionId(index);
                        setSelectedAccountSection(gridItem);
                    }
                }
            });
            setGridData({groups: ['Type: Branches', 'Type: Sub-branches'], items: [accountSectionsBranch, accountSectionsSubBranch]});
        }
    }

    useEffect(() => {
        if (!loadedPage) {
            props.setPageTitle('Account sections');
            fetchFundSections();
            setLoadedPage(true);
        }

        fetchFundTypes();
        rebuildGridData(accountSections);
        setAccountingYear(props.baseYear);
    }, [props.baseYear]);

    useEffect(() => {
        rebuildGridData(accountSections);
    }, [accountSections]);

    useEffect(() => {
        rebuildGridData(accountSections);

        setRecordType(1);
        setAccountingYear(props.baseYear);
        setSectionDescription('');
        setSectionNumber(0);
        setReceiptPayment(1);
        setReportSection(0);
        setCarriedForwardBalanceLine(false);
        setBroughtForwardBalanceLine(false);

        setSelectedAccountSection(null);
        setSelectedAccountSectionId(null);
        setNeedsValidation(false);
    }, [selectedFundTypeCode]);

    useEffect(() => {
        if (tabs.length > 0) {
            let selectedTab = tabs.find((itm) => itm.FundTypeCode.replace(/\s/g, '') === subTabPath);
            if (selectedTab) {
                setSelectedFundTypeCode(selectedTab.FundTypeCode);
            }
        }
    }, [subTabPath]);

    useEffect(() => {
        if (isAddAccountSectionMode) {
            setNeedsValidation(false);
            setRecordType(1);
            setAccountingYear(props.baseYear);
            setSectionDescription('');
            setSectionNumber(0);
            setReceiptPayment(1);
            setReportSection(0);
            setCarriedForwardBalanceLine(false);
            setBroughtForwardBalanceLine(false);
        } else if (selectedAccountSection) {
            setNeedsValidation(false);
            setRecordType(selectedAccountSection.RecordType);
            setAccountingYear(selectedAccountSection.AccountingYear);
            setSectionDescription(selectedAccountSection.SectionDescription);
            setSectionNumber(selectedAccountSection.SectionNumber);
            setReceiptPayment(selectedAccountSection.ReceiptPayment);
            setReportSection(selectedAccountSection.ReportSection);
            setCarriedForwardBalanceLine(selectedAccountSection.CarriedForwardBalanceLine);
            setBroughtForwardBalanceLine(selectedAccountSection.BroughtForwardBalanceLine);
        }
    }, [isAddAccountSectionMode]);

    useEffect(() => {
        if (selectedAccountSection) {
            setRecordType(selectedAccountSection.RecordType);
            setAccountingYear(selectedAccountSection.AccountingYear);
            setSectionDescription(selectedAccountSection.SectionDescription);
            setSectionNumber(selectedAccountSection.SectionNumber);
            setReceiptPayment(selectedAccountSection.ReceiptPayment);
            setReportSection(selectedAccountSection.ReportSection);
            setCarriedForwardBalanceLine(selectedAccountSection.CarriedForwardBalanceLine);
            setBroughtForwardBalanceLine(selectedAccountSection.BroughtForwardBalanceLine);
        } else {
            setNeedsValidation(false);
            setRecordType(1);
            setAccountingYear(props.baseYear);
            setSectionDescription('');
            setSectionNumber(0);
            setReceiptPayment(1);
            setReportSection(0);
            setCarriedForwardBalanceLine(false);
            setBroughtForwardBalanceLine(false);
        }
    }, [selectedAccountSection]);

    useEffect(() => {
        setIsAddingDuplicatedAccountSection(false);
    }, [recordType, accountingYear, selectedFundTypeCode, sectionNumber]);

    useEffect(() => {
        setIsAddingDuplicatedAccountSection(false);
        setNeedsValidation(false);
    }, [props.baseYear, selectedAccountSection, isAddAccountSectionMode]);

    return (
        <StyledAccountSections>
            {tabs.length > 0 && <>
            <div style={{marginLeft:30}}>
                <TabBar tabs={tabs} defaultPath={defaultPath} selectedSubTabPath={subTabPath ? subTabPath : defaultTabPath}></TabBar>
            </div>
            <WhiteBoard>
                <div style={{display:'flex'}}>
                    <div>
                        <NarrowGrid id='systemstructure_accounttypes_grid' gridColumns={gridColumns} gridData={gridData} disabled={isAddAccountSectionMode} itemIdToSelect={selectedAccountSectionId} onSelectGridItem={onSelectGridItem} gridStyle={{width:300, height:400}}></NarrowGrid>
                        <div style={{marginTop:20}}>
                            {selectedAccountSection && !isAddAccountSectionMode && <SecondaryButton caption='Delete' isLoading={isDeletingAccountSection} onClick={() => onDeleteFundSection()} style={{width:75, height:25}}></SecondaryButton>}
                            {isAddAccountSectionMode && <SecondaryButton caption='Cancel' onClick={() => setIsAddAccountSectionMode(false)} style={{width:75, height:25, float:'right'}}></SecondaryButton>}
                            {!isAddAccountSectionMode && <PrimaryButton caption='Create new' onClick={() => setIsAddAccountSectionMode(true)} style={{width:100, height:25, float:'right'}}></PrimaryButton>}
                        </div>
                    </div>
                    <div style={{marginLeft:30}}>
                        <div style={{display:'flex'}}>
                            <FormSelectWithLabel label='Type' items={branchTypes} value={branchTypes[recordType-1]} disabled={!isAddAccountSectionMode && !selectedAccountSection} onChange={(e) => onChangeRecordType(e)} style={{width:220, height:35, paddingLeft:10}} selectStyle={{paddingTop:0}}></FormSelectWithLabel>
                            <FormSelectWithLabel label='Year' items={years} value={accountingYear} disabled={!isAddAccountSectionMode && !selectedAccountSection} onChange={(e) => setAccountingYear(parseInt(e.target.value))} style={{width:100, height:35, paddingLeft:10, marginLeft:30}} selectStyle={{paddingTop:0}} labelStyle={{marginLeft:30}}></FormSelectWithLabel>
                        </div>
                        
                        <div style={{display:'flex'}}>
                            <FormStringInput label='Description' value={sectionDescription} disabled={!isAddAccountSectionMode && !selectedAccountSection} validated={needsValidation && sectionDescription.length===0 ? false : undefined} onChange={(val) => setSectionDescription(val)} inputStyle={{width:220}}></FormStringInput>
                            <FormStringInput label='Account type' value={selectedFundTypeCode} disabled={true} inputStyle={{width:100}} style={{marginLeft:30}}></FormStringInput>
                        </div>
                        <FormNumberInputNoSpinner label='Section' value={sectionNumber} disabled={!isAddAccountSectionMode && !selectedAccountSection} onChange={(val) => setSectionNumber(val)} inputStyle={{width:100, height:35}}></FormNumberInputNoSpinner>

                        <div style={{display:'flex'}}>
                            <FormSelectWithLabel label='Section type' items={sectionTypes} value={sectionTypes[receiptPayment-1]} disabled={!isAddAccountSectionMode && !selectedAccountSection} onChange={(e) => onChangeReceiptPayment(e)} style={{width:220, height:35, paddingLeft:10}}></FormSelectWithLabel>
                            <FormNumberInputNoSpinner label='Report area' value={reportSection} disabled={!isAddAccountSectionMode && !selectedAccountSection} onChange={(val) => setReportSection(val)} inputStyle={{width:100, height:35}} style={{marginLeft:30}}></FormNumberInputNoSpinner>
                        </div>

                        <FormCheckBoxWithRightLabel label='Carried forward balance line' checked={carriedForwardBalanceLine} disabled={!isAddAccountSectionMode && !selectedAccountSection} onCheck={(val) => setCarriedForwardBalanceLine(val)} style={{paddingTop:30}}></FormCheckBoxWithRightLabel>
                        <FormCheckBoxWithRightLabel label='Brought forward balance line' checked={broughtForwardBalanceLine} disabled={!isAddAccountSectionMode && !selectedAccountSection} onCheck={(val) => setBroughtForwardBalanceLine(val)} style={{paddingTop:12}}></FormCheckBoxWithRightLabel>

                        {isAddingDuplicatedAccountSection && <div style={{marginTop:20, width:280, fontSize:12, fontWeight:700, color:'#dc3545'}}>* Section number is duplicated.</div>}
                    </div>
                </div>
            </WhiteBoard>
            <div>
                <PrimaryButton caption={isAddAccountSectionMode ? 'Add account section' : 'Save changes'} isLoading={isSaving} onClick={() => onSaveChanges()} disabled={isAddAccountSectionMode || selectedAccountSection ? false : true} style={{width:150, float:'right'}}></PrimaryButton>
            </div>
            </>}
            {(tabs.length === 0 && isFetchedAccountTypes) && <h4 style={{marginLeft:30}}>No account types in {props.baseYear}</h4>}
        </StyledAccountSections>
    )
}

export default AccountSections;